import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';

export enum SearchFieldType {
  TextBox,
  DropDownList,
}

export class SearchField {
  public name: string;
  public displayName: string;
  public fieldType: SearchFieldType;
  public selectItems: ListItem[] | undefined;
  public filterValue: string | undefined;

  constructor(field: Partial<SearchField>) {
    if (!field.name) {
      throw 'error in search field: missing search field id';
    } else if (!field.displayName || field.displayName == '') {
      throw 'error in search field: missing display name';
    } else if (field.fieldType == undefined) {
      throw 'error in search field: missing field type';
    } else if (
      field.fieldType == SearchFieldType.DropDownList &&
      (!field.selectItems || field.selectItems.length == 0)
    ) {
      throw (
        'error is search field: select items required for ' +
        SearchFieldType.DropDownList
      );
    }

    this.name = field.name;
    this.displayName = field.displayName;
    this.fieldType = field.fieldType;
    this.selectItems = field.selectItems;
    this.filterValue = field.filterValue;
  }
}
